var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccountDropdown',{staticClass:"btn-primary",attrs:{"label":_vm.name,"actions":_vm.actions}})}
var staticRenderFns = []

export { render, staticRenderFns }